"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Link = exports.LinkTD = exports.TD = exports.TR = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactResponsive = require("react-responsive");

var _typography = require("../typography");

var _Body = require("../typography/Body");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DesktopTable = _styledComponents.default.table.withConfig({
  displayName: "DesktopTable",
  componentId: "cfjpye-0"
})(["width:100%;border-collapse:collapse;thead tr{border-bottom:1px solid #d8d8d8;}th{padding:8px;white-space:nowrap;text-align:left;}tbody tr{height:64px;padding:8px 0;border-bottom:1px solid #d8d8d8;}td{", ";padding:0 8px;}tbody tr:hover,tbody tr[aria-selected='true']{background:", ";}td:first-child,th:first-child{padding-left:16px;}td:last-child,th:last-child{padding-right:16px;}"], _Body.bodyStyle, (0, _helpers.color)('neutral-1'));

var MobileTableContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileTableContainer",
  componentId: "cfjpye-1"
})(["padding-bottom:16px;padding-top:16px;border-bottom:1px solid #d8d8d8;"]);

var MobileTables = _styledComponents.default.div.withConfig({
  displayName: "MobileTables",
  componentId: "cfjpye-2"
})(["", ":nth-child(even){background:#fafafa;}"], MobileTableContainer);

var MobileTable = _styledComponents.default.table.withConfig({
  displayName: "MobileTable",
  componentId: "cfjpye-3"
})(["border-collapse:collapse;width:100%;td,th{padding-top:4px;}td{padding-right:16px;padding-left:8px;}th{text-align:left;width:10rem;padding-left:16px;padding-right:8px;}"]);

var TR = function TR(_ref) {
  var children = _ref.children,
      _ref$headings = _ref.headings,
      headings = _ref$headings === void 0 ? [] : _ref$headings,
      props = _objectWithoutProperties(_ref, ["children", "headings"]);

  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });

  if (isDesktop) {
    return _react.default.createElement("tr", props, children);
  }

  var cols = _react.default.Children.toArray(children);

  return _react.default.createElement(MobileTableContainer, null, _react.default.createElement(MobileTable, null, _react.default.createElement("tbody", null, cols.map(function (c, i) {
    return _react.default.createElement("tr", {
      key: headings[i]
    }, _react.default.createElement("th", null, _react.default.createElement(_typography.Subtitle2, null, headings[i])), c);
  }))));
};

exports.TR = TR;

var TD = _styledComponents.default.td.withConfig({
  displayName: "TD",
  componentId: "cfjpye-4"
})(["", ";"], _Body.bodyStyle);

exports.TD = TD;

var LinkTD = _styledComponents.default.td.withConfig({
  displayName: "LinkTD",
  componentId: "cfjpye-5"
})(["&&{padding:0;}&&:first-child{padding-left:0;}div{padding:0 8px;}&&:first-child div{padding-left:16px;}"]);

exports.LinkTD = LinkTD;

var Link = function Link(_ref2) {
  var to = _ref2.to,
      _ref2$link = _ref2.link,
      Link = _ref2$link === void 0 ? _typography.Link : _ref2$link,
      children = _ref2.children;
  return _react.default.createElement(LinkTD, null, _react.default.createElement(Link, {
    to: to
  }, _react.default.createElement("div", null, children)));
};

exports.Link = Link;

var Table = function Table(_ref3) {
  var children = _ref3.children,
      headings = _ref3.headings;
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });

  if (isDesktop) {
    return _react.default.createElement(DesktopTable, null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, headings.map(function (e) {
      return _react.default.createElement("th", {
        key: e
      }, _react.default.createElement(_typography.Subtitle2, null, e));
    }))), _react.default.createElement("tbody", null, children));
  }

  var rows = _react.default.Children.toArray(children);

  return _react.default.createElement(MobileTables, null, rows.map(function (row) {
    return _react.default.cloneElement(row, {
      headings: headings
    });
  }));
};

Table.Row = TR;
Table.Col = TD;
Table.LinkCol = Link;
var _default = Table;
exports.default = _default;